import React from "react";

export default function progressBar({progressStatus}) {
  return (
    <>


<ol className="flex items-center w-full text-sm font-medium text-center text-gray-500 dark:text-gray-400 sm:text-base">
    <li className={`flex md:w-full items-center ${progressStatus.stepOne && 'text-blue-600'} dark:text-blue-500 sm:after:content-[''] after:w-full after:h-1 after:border-b after:border-gray-200 after:border-1 after:hidden sm:after:inline-block after:mx-6 xl:after:mx-10 dark:after:border-gray-700`}>
        <span className="flex items-center after:content-['/'] sm:after:hidden after:mx-2 after:text-gray-200 dark:after:text-gray-500">
            {progressStatus.stepOne && <svg className="w-3.5 h-3.5 sm:w-4 sm:h-4 me-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
            </svg>}
            Personal <span className="hidden sm:inline-flex sm:ms-2">Info</span>
        </span>
    </li>
    <li className={`flex md:w-full items-center ${progressStatus.stepTwo && 'text-blue-600'} after:content-[''] after:w-full after:h-1 after:border-b after:border-gray-200 after:border-1 after:hidden sm:after:inline-block after:mx-6 xl:after:mx-10 dark:after:border-gray-700`}>
        <span className="flex items-center after:content-['/'] sm:after:hidden after:mx-2 after:text-gray-200 dark:after:text-gray-500">
        {progressStatus.stepTwo && <svg className="w-3.5 h-3.5 sm:w-4 sm:h-4 me-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
            </svg>}
            <span className="me-2">2</span>
            Organization <span className="hidden sm:inline-flex sm:ms-2">Info</span>
        </span>
    </li>
    <li className={`flex items-center ${progressStatus.stepThree && 'text-blue-600'}`}>
    {progressStatus.stepThree && <svg className="w-3.5 h-3.5 sm:w-4 sm:h-4 me-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
            </svg>}
        <span className="me-2">3</span>
        Verification
    </li>
</ol>

        {/* <ol className=" mb-20 text-center w-full flex justify-between sm:flex sm:space-x-8 sm:space-y-0">
          <li className="flex items-center text-blue-600 dark:text-blue-500 space-x-2.5">
            <span className={`flex items-center justify-center ${progressStatus.stepOne ? 'bg-[#3fb43f]': 'bg-[#FF3800]' } w-8 h-8 border border-blue-600 rounded-full shrink-0 dark:border-blue-500`}>
              1
            </span>
            <span>
              <h3 className="font-medium leading-tight">User info</h3>
            </span>
          </li>
          <li className="flex items-center text-gray-500 dark:text-gray-400 space-x-2.5">
            <span className={`flex items-center justify-center ${progressStatus.stepTwo ? 'bg-[#3fb43f]': 'bg-[#fff]' } w-8 h-8 border border-gray-500 rounded-full shrink-0 dark:border-gray-400`}>
              2
            </span>
            <span>
              <h3 className="font-medium leading-tight">Company info</h3>
            </span>
          </li>
          <li className="flex items-center text-gray-500 dark:text-gray-400 space-x-2.5">
            <span className={`flex items-center justify-center ${progressStatus.stepFour ? 'bg-[#3fb43f]': 'bg-[#fff]' } w-8 h-8 border border-gray-500 rounded-full shrink-0 dark:border-gray-400`}>
              3
            </span>
            <span>
              <h3 className="font-medium leading-tight">Email verification</h3>
            </span>
          </li>
        </ol> */}
    </>
  );
}
